export const emptyAdditionalData = {
  line2: '',
  company: '',
};
